import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import clone from 'clone';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import { required } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import LoadImage from '../../components/LoadImage';
import PICTURE_TYPES from '../../constants/pictureTypes';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class PictureForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    picture: PropTypes.shape({
      type: PropTypes.string,
    }),
    tags: PropTypes.arrayOf(PropTypes.object),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    label: '',
    type: 'general',
    tags: [],
  }
  static mapStateToProps = state => ({
    tags: state.tags.data.picture,
  })
  constructor(props) {
    super(props);
    const picture = Object.assign({}, PictureForm.defaultValues, props.picture || {});
    const tags = props.tags ? [].concat(props.tags).map(t => ({
      text: t.name,
      value: t.name,
    })) : [];
    const options = _.unionBy(tags, this.getTagOptions(picture.tags), 'value');
    this.state = {
      picture,
      oriPicture: clone(picture),
      options,
      errMessages: [],
    };
    this.validation = {
      label: createRef(),
      type: createRef(),
      tags: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    let picture = Object.assign({}, PictureForm.defaultValues, this.state.picture);
    let oriPicture = this.state.oriPicture;
    if (JSON.stringify(this.props.picture) !== JSON.stringify(nextProps.picture)) {
      picture = Object.assign(picture, nextProps.picture);
      oriPicture = clone(picture);
    }
    const tags = nextProps.tags ? [].concat(nextProps.tags).map(t => ({
      text: t.name,
      value: t.name,
    })) : [];
    const options = _.unionBy(tags, this.getTagOptions(picture.tags), 'value');
    this.setState({
      picture,
      oriPicture,
      options,
    });
  }
  getTagOptions = (tags) => {
    if (tags && tags.length > 0) {
      return tags.map(value => ({
        text: value,
        value,
      }));
    }
    return [];
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { picture } = this.state;
    picture.label = picture.label.trim();
    AppForm.validate(this.validation, picture)
      .then((validations) => {
        this.props.onSubmit(validations, picture);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleInputChange = (event, { name, value }) => {
    const { picture } = this.state;
    let newValue = value;
    if (name === 'label') {
      newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    }
    picture[name] = newValue;
    this.setState({ picture }, () => {
      this.handleCheckChanges();
    });
  }
  handleAddition = (e, { value }) => {
    const { options } = this.state;
    if (!options.some(o => o.value === value)) {
      this.setState({
        options: [{ text: value, value }, ...options],
      });
    }
  }
  render() {
    const { t } = this.props;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <LoadImage
                wrapped
                picture={this.state.picture}
                pictureSize={100}
              />
            </Grid.Column>
            <Grid.Column>
              <AppForm.Input
                label={t('Label')}
                type="text"
                name="label"
                value={this.state.picture.label}
                onChange={this.handleInputChange}
                ref={this.validation.label}
              />
              <AppForm.Validate
                validation={[required]}
                ref={this.validation.type}
                onChange={this.handleInputChange}
              >
                <Form.Select
                  label={t('Type')}
                  name="type"
                  options={PICTURE_TYPES.map(status => ({
                    ...status,
                    text: t(status.text, { ns: TRANSLATION_FILES.screens }),
                  }))}
                  placeholder={t('Type')}
                  search
                  selection
                  fluid
                  value={this.state.picture.type}
                />
              </AppForm.Validate>
              <AppForm.Validate
                ref={this.validation.tags}
                onChange={this.handleInputChange}
              >
                <Form.Select
                  label={t('Tags')}
                  name="tags"
                  fluid
                  placeholder={t('Add tags')}
                  noResultsMessage={t('Add tags')}
                  search
                  selection
                  multiple
                  allowAdditions
                  options={this.state.options}
                  value={this.state.picture.tags || []}
                  onAddItem={this.handleAddition}
                />
              </AppForm.Validate>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(
  connect(
    PictureForm.mapStateToProps, null, null, { withRef: true },
  )(PictureForm),
);



// WEBPACK FOOTER //
// ./src/containers/Picture/Form.jsx